<ng-container *ngIf="!env.ONBOARDING?.RECOVER_PASSWORD_NEW">
    <div class="progress-wrapper" *ngIf="!formerCustomerFirstVisit">
        <ridango-page-content-wrapper>
            <ridango-progress-v2 [steps]="steps" [activeStep]="step"></ridango-progress-v2>
        </ridango-page-content-wrapper>
    </div>

    <div class="block--content block" id="main-content">
        <div class="block--wrap block">
            <rwidget-alert></rwidget-alert>
            <ridango-page-content-wrapper>
                <div class="ticket">
                    <div class="block__left-side-panel">
                        <rwidget-reset-password-aside
                            [formerCustomerFirstVisit]="formerCustomerFirstVisit"></rwidget-reset-password-aside>
                    </div>

                    <div class="block__right-side-panel">
                        <rwidget-reset-password
                            [callback]="callback"
                            (onResetComplete)="handleResetComplete($event)"></rwidget-reset-password>
                    </div>
                </div>
            </ridango-page-content-wrapper>
        </div>
    </div>
</ng-container>

<gl-reset-password-v2
    *ngIf="env.ONBOARDING?.RECOVER_PASSWORD_NEW"
    (resetComplete)="handleResetComplete($event)"></gl-reset-password-v2>
